export default __webpack_public_path__ + "static/media/gamevy.a51f4faa.png";